

























import Vue from 'vue';
import MessageBox from '@/mass/components/common/MessageBox.vue';
import  {  Factory, ScheduleMsgDisplayInfo, ScheduleMsg, transDiv, transValue } from '@/rule/models/ScheduleMsg';
import FormatEmoji from '@/common/utils/FormatEmoji';
import scheduleRuleVuex from '../../../vuex/common';

export default Vue.extend({
  mixins:[scheduleRuleVuex],
  components: {
    MessageBox,
  },
  data() {
    return {
      msg: {} as ScheduleMsg,
      info: {} as ScheduleMsgDisplayInfo,

    };
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName =
          '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
  },
  props: {
    initData: {
      type: Object,
    },
  },
  methods: {
    commitMsg() {
      const hasMsg = this.msg && (this.msg.WxCard || this.msg.WxText || this.msg.WxNews || this.msg.WxTpl || this.msg.WxImage);
      if(hasMsg) {
        let out = this.msg;
        const txt = this.msg.WxText;
        if(txt) {
          if (txt.propConfigs) {
            const formattedTxt = transDiv(transValue(this.tranProps, FormatEmoji.toEmoji(txt.text)))
            out = {
              WxText: {
                text: formattedTxt,
                propConfigs: txt.propConfigs,
              },
            }
          } else {
            const formattedTxt = transDiv(FormatEmoji.toEmoji(txt.text))
            out = {
              WxText: {
                text: formattedTxt,
              },
            }
          }
        }
        this.$store.commit('UPDATE_SCHEDULE_MSG', out);
        this.$store.commit('HIDE_WX_TPL_TEMPLATE_TIP');
        this.$emit('updateMsg', this.info);
      }
      this.$emit('close');
    },
    selectText(val: string): void {
      if(!this.msg.WxText) {
        this.msg = Factory.fromText(val);
      } else {
        this.msg.WxText.text = val;
      }

    },
    updateCouponText(val: string): void {
      if(val) {
        this.msg = Factory.fromCardLink(val);
      }
    },
    selectImage(val: any): void {
      this.msg = Factory.fromImage(val.mediaId, val.url);
    },
    selectNews(val: any): void {
      //后端会重新获取
      this.msg = Factory.fromNews(val.parentNews, []);
    },
    selectCoupon(val: any): void {
      this.msg = Factory.fromWxCard(val.cardId);
      this.info.cardInfo = val;
    },
    updatePropConfigs(val: any): void { // 目前只有 文本才能插入变量
      if(this.msg.WxText) {
        this.msg.WxText.propConfigs = val;
      }
    },
    confirm(): void {
      this.commitMsg();
    },
  },
});
